export default class CartaoCreditoModel {
  public numero: string = "";
  public nomeImpresso: string = "";
  public cpfTitular: string = "";
  public validade: string = "";
  public codigoSeguranca: string = "";
  public bandeira: string = "";
}

export enum CartaoCreditoEnum {
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  AMEX = "AMEX",
  ELO = "ELO",
  HIPERCARD = "HIPERCARD"
}

export enum CartaoCreditoClearsaleEnum {
  VISA = 3,
  MASTERCARD = 2,
  ELO = 10,
  DINERS = 1,
  OUTROS = 4,
  HIPERCARD = 6,
  LEADERCARD = 50,
  FORTBRASIL = 100,
  SOROCRED = 101,
  CARTAOMAIS = 103,
  CARTAOCEA = 105,
  AMEX = 5,
  AURA = 7,
}